import { IconButton } from "@similarweb/ui-components";

import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { translate } from "app/filters/i18nFilter";
import { REPLACE } from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/modal.texts";

import {
    StyledHeaderText,
    StyledModalHeader,
    StyledReplaceWrapper,
} from "../../containers/EnrichmentCsvContainer/style";

import type { HeaderProps } from "./type";

export const Header = ({
    onClick,
    tooltipContent = REPLACE,
    title,
    iconName,
    iconSize = "sm",
    className,
}: HeaderProps) => {
    return (
        <StyledModalHeader>
            <StyledHeaderText>{translate(title)}</StyledHeaderText>
            {onClick && iconName ? (
                <StyledReplaceWrapper className="close-enrich-popup">
                    <PlainTooltip
                        placement="bottom"
                        enabled
                        text={translate(tooltipContent)}
                    >
                        <div className={className}>
                            <IconButton
                                dataAutomation={`${iconName}-enrich-csv`}
                                type="flat"
                                iconName={iconName}
                                onClick={onClick}
                                iconSize={iconSize}
                            />
                        </div>
                    </PlainTooltip>
                </StyledReplaceWrapper>
            ) : null}
        </StyledModalHeader>
    );
};
